module.exports = "images/meet-the-mad-scientists_poster@3x.webp";